import {useRef} from 'react'

// Nhiều nơi truyền array literal inline (vd formSchema={[schema.a, schema.b]}) - array này là
// object mới mỗi render dù các phần tử bên trong (schema.a, schema.b...) vẫn là cùng 1 reference.
// Nếu dùng thẳng array đó làm dependency cho useMemo/useEffect, nó sẽ "đổi" mỗi render dù nội
// dung không đổi, khiến field/component con bên trong bị tính toán lại hoặc remount liên tục.
//
// useStableArray giữ lại reference CŨ nếu length + từng phần tử (so sánh ===) không đổi so với
// lần trước, để các hook phía sau dùng làm dependency mà không cần caller tự nhớ memo hoá.
const useStableArray = (array = []) => {
    const ref = useRef(array)

    const isSame =
        ref.current.length === array.length &&
        ref.current.every((item, i) => item === array[i])

    if (!isSame) {
        ref.current = array
    }

    return ref.current
}

export default useStableArray
